export default __webpack_public_path__ + "static/media/shc_logo.ce090bf4.jpg";